import { Pagination } from '@/constants/pagination';
import { PaginationAPI } from '@/types/pagination';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type RuleState = {
  dataAllRule: RuleType[];
  pagination: PaginationAPI;
  totalElements?: number;
};

export const ruleInitialState: RuleState = {
  dataAllRule: [],
  pagination: {
    pageNumber: Pagination.pageNumber,
    totalPages: 0,
    totalElements: 0,
    pageSize: Pagination.pageSize,
  },
};

export const slice = createSlice({
  name: 'rule',
  initialState: ruleInitialState,
  reducers: {
    setListRuleAction(
      state,
      {
        payload,
      }: PayloadAction<{
        data: RuleType[];
        pagination?: PaginationAPI;
        totalElements?: number;
      }>,
    ) {
      state.dataAllRule = payload.data;
      state.pagination = payload.pagination || state.pagination;
      state.totalElements = payload.pagination?.totalElements;
    },

    addRuleAction(state, { payload }: PayloadAction<RuleType>) {
      state.dataAllRule = [payload, ...state.dataAllRule];
      state.pagination = {
        ...state.pagination,
        pageSize: state.pagination.pageSize + 1,
        totalElements: state.pagination.totalElements + 1,
      };
    },

    deleteRuleAction(state, { payload }: PayloadAction<string>) {
      state.dataAllRule = state.dataAllRule.filter((item) => !payload.includes(item.id!));
    },

    updateRuleAction(state, { payload }: PayloadAction<RuleType>) {
      state.dataAllRule = state.dataAllRule.map((item) => {
        if (item?.id === payload?.id) {
          return payload;
        }
        return item;
      });
    },
  },
});

export const { setListRuleAction, addRuleAction, deleteRuleAction, updateRuleAction } =
  slice.actions;

export default slice.reducer;
